<template>
    <div>
      <vue-headful
      title="Dashboard | Edit Business Card"
      description="Dashboard | Edit Business Card"
  />
  
      <div>
          <nav style="position: fixed;width: 100%;height: 71px;background: #ffffff;border-bottom: 1px solid #dde1ed;z-index: 99;">
              <div style="display: flex;align-items: center;height: 100%;justify-content: space-between;margin-left: 20px;margin-right: 20px;">
                  <router-link to="/dashboard/business-cards" class="btn btn-light"><i class="fa-solid fa-chevron-left mr-2"></i> Back</router-link>
                  <button v-if="!finishing_business_card" @click="save_business_card" class="btn btn-success">Finish</button>
                  <button v-if="finishing_business_card" class="btn btn-success">Finishing...</button>
              </div>
          </nav>
  
  
  
  
  
          <!-- MOBILE SIDEBAR -->
          <div class="d-lg-none" style="position: fixed;bottom: -1px;left: 0px;background: rgb(255, 255, 255);width: -webkit-fill-available;box-shadow: rgba(170, 170, 170, 0.18) 10px 10px 10px 10px !important;z-index: 2;">
          <div v-if="tab !== ''" style="padding: 10px 10px 0 10px">
            <div class="d-flex align-items-center justify-content-between" style="border-bottom: 1px solid #e8e8e8;">
              <p v-if="tab === 'information' || tab === ''" class="display-4 mb-0">Information</p>
              <p v-if="tab === 'design'" class="display-4 mb-0">Design</p>
              <button @click="change_tab('')" class="btn d-flex align-items-center pt-2 pb-2 pl-2 pr-0" style="font-size: 23px;">
                <i class="fa-solid fa-square-xmark ml-1"></i>
              </button>
            </div>
            <div class="overflow-auto col-12 height-navigation-mobile_emailsignature" style="width: 100%;padding-top: 15px;">
      
      
      
      
            <div class="pt-2">
            <!-- PLACEHOLDER -->
            <div v-if="loading_business_card">
                <div style="background: #dddddd;height: 200px;border-radius: 0.5rem;"><div class="shine200"></div></div>
                <div class="mt-3" style="background: #dddddd;height: 20px;border-radius: 0.5rem;"><div class="shine20"></div></div>
                <div class="mt-3" style="background: #dddddd;height: 20px;border-radius: 0.5rem;"><div class="shine20"></div></div>
                <div class="mt-3" style="background: #dddddd;height: 20px;border-radius: 0.5rem;"><div class="shine20"></div></div>
            </div>
            <div v-else>
              <!-- INFORMATION -->
              <div v-if="tab === 'information' || tab === ''">
                  <div class="p-3 mb-3" style="border: 2px solid #dde1ed; border-radius: 8px;">
                      <div class="d-flex align-items-center mb-3">
                          <div class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;"><i class="fa-solid fa-a" style="color: rgb(154 154 154);font-size: 23px;margin-left: 3px;"></i></div>
                          <p class="lead col m-0">Information</p>
                      </div>
                      <div class="mb-3">
                          <p class="mb-2">Name</p>
                          <input v-model="name" type="text"  placeholder="John Doe" class="form-control">
                      </div>
                      <div class="mb-3">
                          <p class="mb-2">Role</p>
                          <input v-model="role" type="text" placeholder="CEO" class="form-control">
                      </div>
                      <div class="mb-3">
                          <p class="mb-2">Phone</p>
                          <input v-model="phone" type="tel" placeholder="555 555-5555" class="form-control">
                      </div>
                      <div class="mb-3">
                          <p class="mb-2">Email</p>
                          <input v-model="email" type="email" placeholder="hello@website.com" class="form-control">
                      </div>
                      <div class="mb-3">
                          <p class="mb-2">Website</p>
                          <input v-model="website" type="url" placeholder="https://example.com" class="form-control">
                      </div>
                      <div class="mb-3">
                          <p class="mb-2">Address</p>
                          <input v-model="address" type="text" placeholder="123 Main Street" class="form-control">
                      </div>
                  </div>
                  <div class="p-3 mb-3" style="border: 2px solid #dde1ed; border-radius: 8px;">
                      <div class="d-flex align-items-center mb-3">
                          <div class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;"><i class="fa-solid fa-image" style="color: rgb(154 154 154);font-size: 23px;"></i></div>
                          <p class="lead col m-0">Logo</p>
                      </div>
                      <div v-if="logo_unique_id !== ''" class="d-flex align-items-center mb-3">
                        <div class="col">
                            <img v-if="paid_svglogos_s3 === 'needs_update'" :src="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" style="border-radius: 5px;" />
                            <img v-else :src="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" style="border-radius: 5px;" />
                        </div>
                        <div class="col-auto">
                            <button @click="logo_unique_id = ''" class="btn btn-danger mt-2">
                                <i class="fa-solid fa-trash-can"></i>
                            </button>
                        </div>
                      </div>
                      <button @click="show_modal_logo" class="btn btn-primary w-100">Change Logo</button>
                  </div>
                  <div class="p-3 mb-3" style="border: 2px solid #dde1ed; border-radius: 8px;">
                      <div class="d-flex align-items-center mb-3">
                          <div class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;"><i class="fa-solid fa-layer-group" style="color: rgb(154 154 154);font-size: 23px;margin-left: -1px;"></i></div>
                          <p class="lead col m-0">Template</p>
                      </div>
                      <div class="text-center mb-3">
                        <div v-if="template === '1'">
                            <svg xmlns="http://www.w3.org/2000/svg" class="svg-card" preserveAspectRatio="xMidYMid meet" viewBox="0 0 500 250">
                                <!-- Background -->
                                <rect x="0" y="0" width="222" height="250" fill="white"></rect>
                                <rect x="222" y="0" width="278" height="250" :fill="background_color"></rect>

                                <!-- Logo -->
                                <defs>
                                    <clipPath id="roundedClip2">
                                    <rect x="16" y="30" width="190" height="190" rx="5" ry="5"></rect>
                                    </clipPath>
                                </defs>

                                <image v-if="paid_svglogos_s3 === 'needs_update'" :href="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" height="190" width="190" y="30" x="16" clip-path="url(#roundedClip2)"></image>
                                <image v-else :href="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" height="190" width="190" y="30" x="16" clip-path="url(#roundedClip2)"></image>

                                <g ref="textGroup-1" :transform="calculateGroupTransform('1')">
                                    <!-- Name -->
                                    <text v-if="name" x="235" y="0" font-family="Arial" :font-size="calculateFontSize(name, 24)" :fill="name_color">{{name}}</text>

                                    <!-- Role -->
                                    <text v-if="role" x="235" :y="getYPosition('role')" font-family="Arial" :font-size="calculateFontSize(role, 18)" :fill="role_color">{{role}}</text>

                                    <!-- Phone -->
                                    <text v-if="phone" x="235" :y="getYPosition('phone')" font-family="Arial" :font-size="calculateFontSize(phone, 14)" :fill="phone_color">{{phone}}</text>

                                    <!-- Email -->
                                    <text v-if="email" x="235" :y="getYPosition('email')" font-family="Arial" :font-size="calculateFontSize(email, 14)" :fill="email_color">{{email}}</text>

                                    <!-- Website -->
                                    <text v-if="website" x="235" :y="getYPosition('website')" font-family="Arial" :font-size="calculateFontSize(website, 14)" :fill="website_color">{{website}}</text>

                                    <!-- Address -->
                                    <text v-if="address" x="235" :y="getYPosition('address')" font-family="Arial" :font-size="calculateFontSize(address, 14)" :fill="address_color">{{address}}</text>
                                </g>
                            </svg>
                        </div>
                        <div v-if="template === '2'">
                            <svg xmlns="http://www.w3.org/2000/svg" class="svg-card" preserveAspectRatio="xMidYMid meet" viewBox="0 0 500 250">
                                <!-- Background -->
                                <rect x="0" y="0" width="500" height="250" :fill="background_color"></rect>

                                <!-- Logo on the Right Side -->
                                <!-- Define the circle clip path -->
                                <defs>
                                    <clipPath id="circleClip3">
                                    <ellipse cx="400" cy="125" rx="73.5" ry="73.5"/>
                                    </clipPath>
                                </defs>

                                <!-- Image with the circular clip path -->
                                <image v-if="paid_svglogos_s3 === 'needs_update'" :href="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" height="147" width="147" y="51.5" x="326.5" clip-path="url(#circleClip3)"></image>
                                <image v-else :href="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" height="147" width="147" y="51.5" x="326.5" clip-path="url(#circleClip3)"></image>

                                <!-- Text elements -->
                                <g ref="textGroup-2" :transform="calculateGroupTransform('2')">
                                    <text v-if="name" x="30" y="0" font-family="Arial" :font-size="calculateFontSize(name, 24)" :fill="name_color">{{name}}</text>
                                    <text v-if="role" x="30" :y="getYPosition('role')" font-family="Arial" :font-size="calculateFontSize(role, 18)" :fill="role_color">{{role}}</text>
                                    <text v-if="phone" x="30" :y="getYPosition('phone')" font-family="Arial" :font-size="calculateFontSize(phone, 14)" :fill="phone_color">{{phone}}</text>
                                    <text v-if="email" x="30" :y="getYPosition('email')" font-family="Arial" :font-size="calculateFontSize(email, 14)" :fill="email_color">{{email}}</text>
                                    <text v-if="website" x="30" :y="getYPosition('website')" font-family="Arial" :font-size="calculateFontSize(website, 14)" :fill="website_color">{{website}}</text>
                                    <text v-if="address" x="30" :y="getYPosition('address')" font-family="Arial" :font-size="calculateFontSize(address, 14)" :fill="address_color">{{address}}</text>
                                </g>
                            </svg>
                        </div>
                        <div v-if="template === '3'">
                            <svg xmlns="http://www.w3.org/2000/svg" class="svg-card" preserveAspectRatio="xMidYMid meet" viewBox="0 0 500 250">
                                <!-- Background -->
                                <rect x="0" y="0" width="500" height="250" :fill="background_color"></rect>

                                <g transform="translate(470, 0) rotate(90)">
                                    <!-- Logo on the Top Left Side -->
                                    <!-- Define the circle clip path -->
                                    <defs>
                                        <clipPath id="circleClip4">
                                        <ellipse cx="125" cy="100" rx="70" ry="70"/>
                                        </clipPath>
                                    </defs>

                                    <!-- Apply the circle clip path to the logo image -->
                                    <image v-if="paid_svglogos_s3 === 'needs_update'" :href="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" height="140" width="140" y="30" x="55" clip-path="url(#circleClip4)"></image>
                                    <image v-else :href="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" height="140" width="140" y="30" x="55" clip-path="url(#circleClip4)"></image>
                                    
                                    <!-- Text elements -->
                                    <g ref="textGroup-3" transform="translate(0, 240)">
                                        <text v-if="name" x="125" y="0" font-family="Cursive" :font-size="calculateFontSize(name, 24)" :fill="name_color" text-anchor="middle">{{name}}</text>
                                        <text v-if="role" x="125" :y="getYPosition('role')" font-family="Arial" :font-size="calculateFontSize(role, 18)" :fill="role_color" text-anchor="middle">{{role}}</text>
                                        <text v-if="phone" x="125" :y="getYPosition('phone')" font-family="Arial" :font-size="calculateFontSize(phone, 14)" :fill="phone_color" text-anchor="middle">{{phone}}</text>
                                        <text v-if="email" x="125" :y="getYPosition('email')" font-family="Arial" :font-size="calculateFontSize(email, 14)" :fill="email_color" text-anchor="middle">{{email}}</text>
                                        <text v-if="website" x="125" :y="getYPosition('website')" font-family="Arial" :font-size="calculateFontSize(website, 14)" :fill="website_color" text-anchor="middle">{{website}}</text>
                                        <text v-if="address" x="125" :y="getYPosition('address')" font-family="Arial" :font-size="calculateFontSize(address, 14)" :fill="address_color" text-anchor="middle">{{address}}</text>
                                    </g>
                                </g>
                            </svg>
                        </div>
                      </div>
                      <button @click="show_modal_template" class="btn btn-primary w-100">Change Template</button>
                  </div>
              </div>
      
      
      
      
      
              <!-- DESIGN -->
              <div v-if="tab === 'design'">
                <div class="p-3 mb-3" style="border: 2px solid #dde1ed; border-radius: 8px;">
                  <div class="d-flex align-items-center mb-3">
                      <div class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;"><i class="fa-solid fa-palette" style="color: rgb(154 154 154);font-size: 23px;margin-left: 1px;"></i></div>
                      <p class="lead col m-0">Design</p>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Background Color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="background_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="background_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Name Color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="name_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="name_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Role Color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="role_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="role_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Phone Color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="phone_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="phone_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Email Color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="email_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="email_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Website Color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="website_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="website_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Address Color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="address_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="address_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
      
      
      
      
      
      
      
      
            </div>
            </div>
          </div>
          <div class="d-flex" style="white-space: nowrap;overflow: scroll;border-top: 1px solid #dfe0e6;padding: 8px;">
            <a @click="change_tab('information')" class="d-flex flex-column align-items-center p-2 col-6" :class="{ 'active-tab-sidebar-create': tab === 'information' }" style="border-radius: 0.5rem;min-width: 80px;"><i class="fa-solid fa-a mb-2" style="color: rgb(223, 224, 230);"></i> <span class="text-center">Information</span></a>
            <a @click="change_tab('design')" class="d-flex flex-column align-items-center p-2 col-6" :class="{ 'active-tab-sidebar-create': tab === 'design' }" style="border-radius: 0.5rem;min-width: 80px;"><i class="fa-solid fa-palette mb-2" style="color: rgb(223, 224, 230);"></i> <span class="text-center">Design</span></a>
          </div>
          </div>
          <!-- DESKTOP SIDEBAR -->
          <nav id="sidebarMenu" class="sidebar-create d-lg-block bg-dark text-white" style="background-color: #ffffff!important;border-right: 1px solid #dde1ed!important;display: none;">
             <div class="sidebar-inner px-4 pt-6">
                <ul class="nav flex-column sidebar-top-mobile">
                   <p style="margin-left: 11px;margin-bottom: 0.8rem;margin-top: 0.8rem;font-weight: 900;color: rgb(74 80 115);font-size: 15px;"><i class="fas fa-pencil" style="margin-right: 7px;"></i>Business Card</p>
                   <li @click="change_tab('information')" class="nav-item" style="max-width: 100%;">
                     <a class="nav-link collapsed d-flex align-items-center" :class="{ 'active-tab-sidebar-create': tab === 'information' }">
                       <i class="fa-solid fa-a mr-3" style="color: rgb(223, 224, 230);"></i>
                       <span>Information</span>
                     </a>
                   </li>
                   <li @click="change_tab('design')" class="nav-item" style="max-width: 100%;">
                     <a class="nav-link collapsed d-flex align-items-center" :class="{ 'active-tab-sidebar-create': tab === 'design' }">
                       <i class="fa-solid fa-palette" style="color: rgb(223, 224, 230);margin-right: 12px;"></i>
                       <span>Design</span>
                     </a>
                   </li>
                </ul>
             </div>
          </nav>
          <div class="sidebar-create px-4 pt-6 d-lg-block secondary-sidebar" style="display:none;">
      
      
      
      
      
            <div class="pt-2">
            <!-- PLACEHOLDER -->
            <div v-if="loading_business_card">
                <div style="background: #dddddd;height: 200px;border-radius: 0.5rem;"><div class="shine200"></div></div>
                <div class="mt-3" style="background: #dddddd;height: 20px;border-radius: 0.5rem;"><div class="shine20"></div></div>
                <div class="mt-3" style="background: #dddddd;height: 20px;border-radius: 0.5rem;"><div class="shine20"></div></div>
                <div class="mt-3" style="background: #dddddd;height: 20px;border-radius: 0.5rem;"><div class="shine20"></div></div>
            </div>
            <div v-else>
              <!-- INFORMATION -->
              <div v-if="tab === 'information' || tab === ''">
                  <div class="p-3 mb-3" style="border: 2px solid #dde1ed; border-radius: 8px;">
                      <div class="d-flex align-items-center mb-3">
                          <div class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;"><i class="fa-solid fa-a" style="color: rgb(154 154 154);font-size: 23px;margin-left: 3px;"></i></div>
                          <p class="lead col m-0">Information</p>
                      </div>
                      <div class="mb-3">
                          <p class="mb-2">Name</p>
                          <input v-model="name" type="text"  placeholder="John Doe" class="form-control">
                      </div>
                      <div class="mb-3">
                          <p class="mb-2">Role</p>
                          <input v-model="role" type="text" placeholder="CEO" class="form-control">
                      </div>
                      <div class="mb-3">
                          <p class="mb-2">Phone</p>
                          <input v-model="phone" type="tel" placeholder="555 555-5555" class="form-control">
                      </div>
                      <div class="mb-3">
                          <p class="mb-2">Email</p>
                          <input v-model="email" type="email" placeholder="hello@website.com" class="form-control">
                      </div>
                      <div class="mb-3">
                          <p class="mb-2">Website</p>
                          <input v-model="website" type="url" placeholder="https://example.com" class="form-control">
                      </div>
                      <div class="mb-3">
                          <p class="mb-2">Address</p>
                          <input v-model="address" type="text" placeholder="123 Main Street" class="form-control">
                      </div>
                  </div>
                  <div class="p-3 mb-3" style="border: 2px solid #dde1ed; border-radius: 8px;">
                      <div class="d-flex align-items-center mb-3">
                          <div class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;"><i class="fa-solid fa-image" style="color: rgb(154 154 154);font-size: 23px;"></i></div>
                          <p class="lead col m-0">Logo</p>
                      </div>
                      <div v-if="logo_unique_id !== ''" class="d-flex align-items-center mb-3">
                        <div class="col">
                            <img v-if="paid_svglogos_s3 === 'needs_update'" :src="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" style="border-radius: 5px;" />
                            <img v-else :src="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" style="border-radius: 5px;" />
                        </div>
                        <div class="col-auto">
                            <button @click="logo_unique_id = ''" class="btn btn-danger mt-2">
                                <i class="fa-solid fa-trash-can"></i>
                            </button>
                        </div>
                      </div>
                      <button @click="show_modal_logo" class="btn btn-primary w-100">Change Logo</button>
                  </div>
                  <div class="p-3 mb-3" style="border: 2px solid #dde1ed; border-radius: 8px;">
                      <div class="d-flex align-items-center mb-3">
                          <div class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;"><i class="fa-solid fa-layer-group" style="color: rgb(154 154 154);font-size: 23px;margin-left: -1px;"></i></div>
                          <p class="lead col m-0">Template</p>
                      </div>
                      <div class="text-center mb-3">
                        <div v-if="template === '1'">
                            <svg xmlns="http://www.w3.org/2000/svg" class="svg-card" preserveAspectRatio="xMidYMid meet" viewBox="0 0 500 250">
                                <!-- Background -->
                                <rect x="0" y="0" width="222" height="250" fill="white"></rect>
                                <rect x="222" y="0" width="278" height="250" :fill="background_color"></rect>

                                <!-- Logo -->
                                <defs>
                                    <clipPath id="roundedClip2">
                                    <rect x="16" y="30" width="190" height="190" rx="5" ry="5"></rect>
                                    </clipPath>
                                </defs>

                                <image v-if="paid_svglogos_s3 === 'needs_update'" :href="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" height="190" width="190" y="30" x="16" clip-path="url(#roundedClip2)"></image>
                                <image v-else :href="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" height="190" width="190" y="30" x="16" clip-path="url(#roundedClip2)"></image>

                                <g ref="textGroup-4" :transform="calculateGroupTransform('4')">
                                    <!-- Name -->
                                    <text v-if="name" x="235" y="0" font-family="Arial" :font-size="calculateFontSize(name, 24)" :fill="name_color">{{name}}</text>

                                    <!-- Role -->
                                    <text v-if="role" x="235" :y="getYPosition('role')" font-family="Arial" :font-size="calculateFontSize(role, 18)" :fill="role_color">{{role}}</text>

                                    <!-- Phone -->
                                    <text v-if="phone" x="235" :y="getYPosition('phone')" font-family="Arial" :font-size="calculateFontSize(phone, 14)" :fill="phone_color">{{phone}}</text>

                                    <!-- Email -->
                                    <text v-if="email" x="235" :y="getYPosition('email')" font-family="Arial" :font-size="calculateFontSize(email, 14)" :fill="email_color">{{email}}</text>

                                    <!-- Website -->
                                    <text v-if="website" x="235" :y="getYPosition('website')" font-family="Arial" :font-size="calculateFontSize(website, 14)" :fill="website_color">{{website}}</text>

                                    <!-- Address -->
                                    <text v-if="address" x="235" :y="getYPosition('address')" font-family="Arial" :font-size="calculateFontSize(address, 14)" :fill="address_color">{{address}}</text>
                                </g>
                            </svg>
                        </div>
                        <div v-if="template === '2'">
                            <svg xmlns="http://www.w3.org/2000/svg" class="svg-card" preserveAspectRatio="xMidYMid meet" viewBox="0 0 500 250">
                                <!-- Background -->
                                <rect x="0" y="0" width="500" height="250" :fill="background_color"></rect>

                                <!-- Logo on the Right Side -->
                                <!-- Define the circle clip path -->
                                <defs>
                                    <clipPath id="circleClip3">
                                    <ellipse cx="400" cy="125" rx="73.5" ry="73.5"/>
                                    </clipPath>
                                </defs>

                                <!-- Image with the circular clip path -->
                                <image v-if="paid_svglogos_s3 === 'needs_update'" :href="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" height="147" width="147" y="51.5" x="326.5" clip-path="url(#circleClip3)"></image>
                                <image v-else :href="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" height="147" width="147" y="51.5" x="326.5" clip-path="url(#circleClip3)"></image>

                                <!-- Text elements -->
                                <g ref="textGroup-5" :transform="calculateGroupTransform('5')">
                                    <text v-if="name" x="30" y="0" font-family="Arial" :font-size="calculateFontSize(name, 24)" :fill="name_color">{{name}}</text>
                                    <text v-if="role" x="30" :y="getYPosition('role')" font-family="Arial" :font-size="calculateFontSize(role, 18)" :fill="role_color">{{role}}</text>
                                    <text v-if="phone" x="30" :y="getYPosition('phone')" font-family="Arial" :font-size="calculateFontSize(phone, 14)" :fill="phone_color">{{phone}}</text>
                                    <text v-if="email" x="30" :y="getYPosition('email')" font-family="Arial" :font-size="calculateFontSize(email, 14)" :fill="email_color">{{email}}</text>
                                    <text v-if="website" x="30" :y="getYPosition('website')" font-family="Arial" :font-size="calculateFontSize(website, 14)" :fill="website_color">{{website}}</text>
                                    <text v-if="address" x="30" :y="getYPosition('address')" font-family="Arial" :font-size="calculateFontSize(address, 14)" :fill="address_color">{{address}}</text>
                                </g>
                            </svg>
                        </div>
                        <div v-if="template === '3'">
                            <svg xmlns="http://www.w3.org/2000/svg" class="svg-card" preserveAspectRatio="xMidYMid meet" viewBox="0 0 500 250">
                                <!-- Background -->
                                <rect x="0" y="0" width="500" height="250" :fill="background_color"></rect>

                                <g transform="translate(470, 0) rotate(90)">
                                    <!-- Logo on the Top Left Side -->
                                    <!-- Define the circle clip path -->
                                    <defs>
                                        <clipPath id="circleClip4">
                                        <ellipse cx="125" cy="100" rx="70" ry="70"/>
                                        </clipPath>
                                    </defs>

                                    <!-- Apply the circle clip path to the logo image -->
                                    <image v-if="paid_svglogos_s3 === 'needs_update'" :href="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" height="140" width="140" y="30" x="55" clip-path="url(#circleClip4)"></image>
                                    <image v-else :href="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" height="140" width="140" y="30" x="55" clip-path="url(#circleClip4)"></image>
                                    
                                    <!-- Text elements -->
                                    <g ref="textGroup-6" transform="translate(0, 240)">
                                        <text v-if="name" x="125" y="0" font-family="Cursive" :font-size="calculateFontSize(name, 24)" :fill="name_color" text-anchor="middle">{{name}}</text>
                                        <text v-if="role" x="125" :y="getYPosition('role')" font-family="Arial" :font-size="calculateFontSize(role, 18)" :fill="role_color" text-anchor="middle">{{role}}</text>
                                        <text v-if="phone" x="125" :y="getYPosition('phone')" font-family="Arial" :font-size="calculateFontSize(phone, 14)" :fill="phone_color" text-anchor="middle">{{phone}}</text>
                                        <text v-if="email" x="125" :y="getYPosition('email')" font-family="Arial" :font-size="calculateFontSize(email, 14)" :fill="email_color" text-anchor="middle">{{email}}</text>
                                        <text v-if="website" x="125" :y="getYPosition('website')" font-family="Arial" :font-size="calculateFontSize(website, 14)" :fill="website_color" text-anchor="middle">{{website}}</text>
                                        <text v-if="address" x="125" :y="getYPosition('address')" font-family="Arial" :font-size="calculateFontSize(address, 14)" :fill="address_color" text-anchor="middle">{{address}}</text>
                                    </g>
                                </g>
                            </svg>
                        </div>
                      </div>
                      <button @click="show_modal_template" class="btn btn-primary w-100">Change Template</button>
                  </div>
              </div>
      
      
      
      
      
              <!-- DESIGN -->
              <div v-if="tab === 'design'">
                <div class="p-3 mb-3" style="border: 2px solid #dde1ed; border-radius: 8px;">
                  <div class="d-flex align-items-center mb-3">
                      <div class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;"><i class="fa-solid fa-palette" style="color: rgb(154 154 154);font-size: 23px;margin-left: 1px;"></i></div>
                      <p class="lead col m-0">Design</p>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Background Color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="background_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="background_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Name Color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="name_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="name_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Role Color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="role_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="role_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Phone Color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="phone_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="phone_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Email Color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="email_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="email_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Website Color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="website_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="website_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Address Color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="address_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="address_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
      
      
      
      
  
              
            </div>
        </div>  
  
  
  
  
  
  
  
  
  
          <div class="margin-espacio-del-sidebar-create pt-6 pt-lg-0">
            <div v-if="loading_business_card" class="pt-0 pt-lg-6 mb-6 ml-3 mr-3">
                <div class="pt-2">
                    <div style="background: #ffffff;height: 500px;border-radius: 0.5rem;"><div class="shine500_white"></div></div>
                    <div class="mt-3" style="background: #ffffff;height: 20px;border-radius: 0.5rem;"><div class="shine20_white"></div></div>
                    <div class="mt-3" style="background: #ffffff;height: 20px;border-radius: 0.5rem;"><div class="shine20_white"></div></div>
                    <div class="mt-3" style="background: #ffffff;height: 20px;border-radius: 0.5rem;"><div class="shine20_white"></div></div>
                </div>
            </div>
            <div v-else>
                <div class="container pt-2 vertically-centered-on-desktop" style="overflow-x: hidden;">
                    <div class="blog-card col-12 m-auto p-0 pt-lg-6" style="max-width: 500px;">
                        <!-- TEMPLATE 1 -->
                        <div v-if="template === '1'" style="margin-bottom: 20px;">
                            <svg xmlns="http://www.w3.org/2000/svg" class="svg-card" preserveAspectRatio="xMidYMid meet" viewBox="0 0 500 250">
                                <!-- Background -->
                                <rect x="0" y="0" width="222" height="250" fill="white"></rect>
                                <rect x="222" y="0" width="278" height="250" :fill="background_color"></rect>

                                <!-- Logo -->
                                <defs>
                                    <clipPath id="roundedClip3">
                                    <rect x="16" y="30" width="190" height="190" rx="5" ry="5"></rect>
                                    </clipPath>
                                </defs>

                                <image v-if="paid_svglogos_s3 === 'needs_update'" :href="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" height="190" width="190" y="30" x="16" clip-path="url(#roundedClip3)"></image>
                                <image v-else :href="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" height="190" width="190" y="30" x="16" clip-path="url(#roundedClip3)"></image>

                                <g ref="textGroup-7" :transform="calculateGroupTransform('7')">
                                    <!-- Name -->
                                    <text v-if="name" x="235" y="0" font-family="Arial" :font-size="calculateFontSize(name, 24)" :fill="name_color">{{name}}</text>

                                    <!-- Role -->
                                    <text v-if="role" x="235" :y="getYPosition('role')" font-family="Arial" :font-size="calculateFontSize(role, 18)" :fill="role_color">{{role}}</text>

                                    <!-- Phone -->
                                    <text v-if="phone" x="235" :y="getYPosition('phone')" font-family="Arial" :font-size="calculateFontSize(phone, 14)" :fill="phone_color">{{phone}}</text>

                                    <!-- Email -->
                                    <text v-if="email" x="235" :y="getYPosition('email')" font-family="Arial" :font-size="calculateFontSize(email, 14)" :fill="email_color">{{email}}</text>

                                    <!-- Website -->
                                    <text v-if="website" x="235" :y="getYPosition('website')" font-family="Arial" :font-size="calculateFontSize(website, 14)" :fill="website_color">{{website}}</text>

                                    <!-- Address -->
                                    <text v-if="address" x="235" :y="getYPosition('address')" font-family="Arial" :font-size="calculateFontSize(address, 14)" :fill="address_color">{{address}}</text>
                                </g>
                            </svg>
                        </div>
                        <!-- TEMPLATE 2 -->
                        <div v-if="template === '2'" style="margin-bottom: 20px;">
                            <svg xmlns="http://www.w3.org/2000/svg" class="svg-card" preserveAspectRatio="xMidYMid meet" viewBox="0 0 500 250">
                                <!-- Background -->
                                <rect x="0" y="0" width="500" height="250" :fill="background_color"></rect>

                                <!-- Logo on the Right Side -->
                                <!-- Define the circle clip path -->
                                <defs>
                                    <clipPath id="circleClip5">
                                    <ellipse cx="400" cy="125" rx="73.5" ry="73.5"/>
                                    </clipPath>
                                </defs>

                                <!-- Image with the circular clip path -->
                                <image v-if="paid_svglogos_s3 === 'needs_update'" :href="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" height="147" width="147" y="51.5" x="326.5" clip-path="url(#circleClip5)"></image>
                                <image v-else :href="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" height="147" width="147" y="51.5" x="326.5" clip-path="url(#circleClip5)"></image>

                                <!-- Text elements -->
                                <g ref="textGroup-8" :transform="calculateGroupTransform('8')">
                                    <text v-if="name" x="30" y="0" font-family="Arial" :font-size="calculateFontSize(name, 24)" :fill="name_color">{{name}}</text>
                                    <text v-if="role" x="30" :y="getYPosition('role')" font-family="Arial" :font-size="calculateFontSize(role, 18)" :fill="role_color">{{role}}</text>
                                    <text v-if="phone" x="30" :y="getYPosition('phone')" font-family="Arial" :font-size="calculateFontSize(phone, 14)" :fill="phone_color">{{phone}}</text>
                                    <text v-if="email" x="30" :y="getYPosition('email')" font-family="Arial" :font-size="calculateFontSize(email, 14)" :fill="email_color">{{email}}</text>
                                    <text v-if="website" x="30" :y="getYPosition('website')" font-family="Arial" :font-size="calculateFontSize(website, 14)" :fill="website_color">{{website}}</text>
                                    <text v-if="address" x="30" :y="getYPosition('address')" font-family="Arial" :font-size="calculateFontSize(address, 14)" :fill="address_color">{{address}}</text>
                                </g>
                            </svg>
                        </div>
                        <!-- TEMPLATE 3 -->
                        <div v-if="template === '3'" style="margin-bottom: 20px;">
                            <svg xmlns="http://www.w3.org/2000/svg" class="svg-card" preserveAspectRatio="xMidYMid meet" viewBox="0 0 500 250">
                                <!-- Background -->
                                <rect x="0" y="0" width="500" height="250" :fill="background_color"></rect>

                                <g transform="translate(470, 0) rotate(90)">
                                    <!-- Logo on the Top Left Side -->
                                    <!-- Define the circle clip path -->
                                    <defs>
                                        <clipPath id="circleClip6">
                                        <ellipse cx="125" cy="100" rx="70" ry="70"/>
                                        </clipPath>
                                    </defs>

                                    <!-- Apply the circle clip path to the logo image -->
                                    <image v-if="paid_svglogos_s3 === 'needs_update'" :href="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" height="140" width="140" y="30" x="55" clip-path="url(#circleClip6)"></image>
                                    <image v-else :href="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" height="140" width="140" y="30" x="55" clip-path="url(#circleClip6)"></image>

                                    <!-- Text elements -->
                                    <g ref="textGroup-9" transform="translate(0, 240)">
                                        <text v-if="name" x="125" y="0" font-family="Cursive" :font-size="calculateFontSize(name, 24)" :fill="name_color" text-anchor="middle">{{name}}</text>
                                        <text v-if="role" x="125" :y="getYPosition('role')" font-family="Arial" :font-size="calculateFontSize(role, 18)" :fill="role_color" text-anchor="middle">{{role}}</text>
                                        <text v-if="phone" x="125" :y="getYPosition('phone')" font-family="Arial" :font-size="calculateFontSize(phone, 14)" :fill="phone_color" text-anchor="middle">{{phone}}</text>
                                        <text v-if="email" x="125" :y="getYPosition('email')" font-family="Arial" :font-size="calculateFontSize(email, 14)" :fill="email_color" text-anchor="middle">{{email}}</text>
                                        <text v-if="website" x="125" :y="getYPosition('website')" font-family="Arial" :font-size="calculateFontSize(website, 14)" :fill="website_color" text-anchor="middle">{{website}}</text>
                                        <text v-if="address" x="125" :y="getYPosition('address')" font-family="Arial" :font-size="calculateFontSize(address, 14)" :fill="address_color" text-anchor="middle">{{address}}</text>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <!-- Back of Business Card -->
                        <div style="margin-bottom: 20px;">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 250" preserveAspectRatio="xMidYMid meet">
                                <!-- Background -->
                                <rect x="0" y="0" width="500" height="250" :fill="background_color"></rect>

                                <!-- Define the circular clip path -->
                                <defs>
                                    <clipPath id="circleClip7">
                                    <ellipse cx="250" cy="125" rx="73.5" ry="73.5"></ellipse>
                                    </clipPath>
                                </defs>

                                <!-- Image centered within the SVG -->
                                <image v-if="paid_svglogos_s3 === 'needs_update'" :href="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" height="147" width="147" y="51.5" x="176.5" clip-path="url(#circleClip7)"></image>
                                <image v-else :href="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" height="147" width="147" y="51.5" x="176.5" clip-path="url(#circleClip7)"></image>

                            </svg>
                        </div>
                    </div>
                </div>
            </div>
          </div>
  
  
  
  
  
  
  
  
  
  
  
      
    </div>
  
    <!-- MODAL TEMPLATE -->
    <div v-if="modal_template" class="modal" style="display: block !important; background: rgba(147, 152, 165, 0.35); overflow: auto;">
        <div v-click-outside="hide_modal_template" class="modal-dialog modal-dialog-centered" style="max-width: 800px;">
            <div class="modal-content">
            <div class="modal-header w-100">
                <p class="lead mb-0">Choose a different template</p>
                <button @click="hide_modal_template" type="button" class="close ml-auto" style="position: absolute; right: 21px;">
                <span>×</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-6 col-md-4">
                        <div @click="update_template('1');" class="aumentarscale_btn" :class="{ 'selectedcontainer': template === '1' }" style="width: 100%; margin-bottom: 20px; border-radius: 0.5rem;transition: transform 100ms, box-shadow 150ms;cursor: pointer;background: #F5F5F5;">
                            <div class="logo-list-sin-borde display-logos-created" style="transition: transform 100ms ease 0s, box-shadow 150ms ease 0s;display: flex;">
                                <svg xmlns="http://www.w3.org/2000/svg" class="svg-card" preserveAspectRatio="xMidYMid meet" viewBox="0 0 500 250">
                                    <!-- Background -->
                                    <rect x="0" y="0" width="222" height="250" fill="white"></rect>
                                    <rect x="222" y="0" width="278" height="250" :fill="background_color"></rect>

                                    <!-- Logo -->
                                    <defs>
                                        <clipPath id="roundedClip4">
                                        <rect x="16" y="30" width="190" height="190" rx="5" ry="5"></rect>
                                        </clipPath>
                                    </defs>

                                    <image v-if="paid_svglogos_s3 === 'needs_update'" :href="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" height="190" width="190" y="30" x="16" clip-path="url(#roundedClip4)"></image>
                                    <image v-else :href="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" height="190" width="190" y="30" x="16" clip-path="url(#roundedClip4)"></image>

                                    <g ref="textGroup-10" :transform="calculateGroupTransform('10')">
                                        <!-- Name -->
                                        <text v-if="name" x="235" y="0" font-family="Arial" :font-size="calculateFontSize(name, 24)" :fill="name_color">{{name}}</text>

                                        <!-- Role -->
                                        <text v-if="role" x="235" :y="getYPosition('role')" font-family="Arial" :font-size="calculateFontSize(role, 18)" :fill="role_color">{{role}}</text>

                                        <!-- Phone -->
                                        <text v-if="phone" x="235" :y="getYPosition('phone')" font-family="Arial" :font-size="calculateFontSize(phone, 14)" :fill="phone_color">{{phone}}</text>

                                        <!-- Email -->
                                        <text v-if="email" x="235" :y="getYPosition('email')" font-family="Arial" :font-size="calculateFontSize(email, 14)" :fill="email_color">{{email}}</text>

                                        <!-- Website -->
                                        <text v-if="website" x="235" :y="getYPosition('website')" font-family="Arial" :font-size="calculateFontSize(website, 14)" :fill="website_color">{{website}}</text>

                                        <!-- Address -->
                                        <text v-if="address" x="235" :y="getYPosition('address')" font-family="Arial" :font-size="calculateFontSize(address, 14)" :fill="address_color">{{address}}</text>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 col-md-4">
                        <div @click="update_template('2');" class="aumentarscale_btn" :class="{ 'selectedcontainer': template === '2' }" style="width: 100%; margin-bottom: 20px; border-radius: 0.5rem;transition: transform 100ms, box-shadow 150ms;cursor: pointer;background: #F5F5F5;">
                            <div class="logo-list-sin-borde display-logos-created" style="transition: transform 100ms ease 0s, box-shadow 150ms ease 0s;display: flex;">
                                <svg xmlns="http://www.w3.org/2000/svg" class="svg-card" preserveAspectRatio="xMidYMid meet" viewBox="0 0 500 250">
                                    <!-- Background -->
                                    <rect x="0" y="0" width="500" height="250" :fill="background_color"></rect>

                                    <!-- Logo on the Right Side -->
                                    <!-- Define the circle clip path -->
                                    <defs>
                                        <clipPath id="circleClip8">
                                        <ellipse cx="400" cy="125" rx="73.5" ry="73.5"/>
                                        </clipPath>
                                    </defs>

                                    <!-- Image with the circular clip path -->
                                    <image v-if="paid_svglogos_s3 === 'needs_update'" :href="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" height="147" width="147" y="51.5" x="326.5" clip-path="url(#circleClip8)"></image>
                                    <image v-else :href="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" height="147" width="147" y="51.5" x="326.5" clip-path="url(#circleClip8)"></image>

                                    <!-- Text elements -->
                                    <g ref="textGroup-11" :transform="calculateGroupTransform('11')">
                                        <text v-if="name" x="30" y="0" font-family="Arial" :font-size="calculateFontSize(name, 24)" :fill="name_color">{{name}}</text>
                                        <text v-if="role" x="30" :y="getYPosition('role')" font-family="Arial" :font-size="calculateFontSize(role, 18)" :fill="role_color">{{role}}</text>
                                        <text v-if="phone" x="30" :y="getYPosition('phone')" font-family="Arial" :font-size="calculateFontSize(phone, 14)" :fill="phone_color">{{phone}}</text>
                                        <text v-if="email" x="30" :y="getYPosition('email')" font-family="Arial" :font-size="calculateFontSize(email, 14)" :fill="email_color">{{email}}</text>
                                        <text v-if="website" x="30" :y="getYPosition('website')" font-family="Arial" :font-size="calculateFontSize(website, 14)" :fill="website_color">{{website}}</text>
                                        <text v-if="address" x="30" :y="getYPosition('address')" font-family="Arial" :font-size="calculateFontSize(address, 14)" :fill="address_color">{{address}}</text>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 col-md-4">
                        <div @click="update_template('3');" class="aumentarscale_btn" :class="{ 'selectedcontainer': template === '3' }" style="width: 100%; margin-bottom: 20px; border-radius: 0.5rem;transition: transform 100ms, box-shadow 150ms;cursor: pointer;background: #F5F5F5;">
                            <div class="logo-list-sin-borde display-logos-created" style="transition: transform 100ms ease 0s, box-shadow 150ms ease 0s;display: flex;">
                                <svg xmlns="http://www.w3.org/2000/svg" class="svg-card" preserveAspectRatio="xMidYMid meet" viewBox="0 0 500 250">
                                    <!-- Background -->
                                    <rect x="0" y="0" width="500" height="250" :fill="background_color"></rect>

                                    <g transform="translate(470, 0) rotate(90)">
                                        <!-- Logo on the Top Left Side -->
                                        <!-- Define the circle clip path -->
                                        <defs>
                                            <clipPath id="circleClip9">
                                            <ellipse cx="125" cy="100" rx="70" ry="70"/>
                                            </clipPath>
                                        </defs>

                                        <!-- Apply the circle clip path to the logo image -->
                                        <image v-if="paid_svglogos_s3 === 'needs_update'" :href="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" height="140" width="140" y="30" x="55" clip-path="url(#circleClip9)"></image>
                                        <image v-else :href="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" height="140" width="140" y="30" x="55" clip-path="url(#circleClip9)"></image>
                                        
                                        <!-- Text elements -->
                                        <g ref="textGroup-12" transform="translate(0, 240)">
                                            <text v-if="name" x="125" y="0" font-family="Cursive" :font-size="calculateFontSize(name, 24)" :fill="name_color" text-anchor="middle">{{name}}</text>
                                            <text v-if="role" x="125" :y="getYPosition('role')" font-family="Arial" :font-size="calculateFontSize(role, 18)" :fill="role_color" text-anchor="middle">{{role}}</text>
                                            <text v-if="phone" x="125" :y="getYPosition('phone')" font-family="Arial" :font-size="calculateFontSize(phone, 14)" :fill="phone_color" text-anchor="middle">{{phone}}</text>
                                            <text v-if="email" x="125" :y="getYPosition('email')" font-family="Arial" :font-size="calculateFontSize(email, 14)" :fill="email_color" text-anchor="middle">{{email}}</text>
                                            <text v-if="website" x="125" :y="getYPosition('website')" font-family="Arial" :font-size="calculateFontSize(website, 14)" :fill="website_color" text-anchor="middle">{{website}}</text>
                                            <text v-if="address" x="125" :y="getYPosition('address')" font-family="Arial" :font-size="calculateFontSize(address, 14)" :fill="address_color" text-anchor="middle">{{address}}</text>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
    <!-- MODAL LOGOS -->
    <div v-if="modal_logo" class="modal" style="display: block !important; background: rgba(147, 152, 165, 0.35); overflow: auto;">
        <div v-click-outside="hide_modal_logo" class="modal-dialog modal-dialog-centered" style="max-width: 800px;">
            <div class="modal-content">
            <div class="modal-header w-100">
                <p class="lead mb-0">Choose a different logo</p>
                <button @click="hide_modal_logo" type="button" class="close ml-auto" style="position: absolute; right: 21px;">
                <span>×</span>
                </button>
            </div>
            <div class="modal-body">
                <div v-if="loading_logos" style="margin: 0 auto;">
                    <center>
                        <lottie-player src="https://logo.app/lottie/logo-design-loading.json" background="transparent" speed="1" style="width:100%; height:100%; max-width: 500px; max-height: 500px;" loop autoplay></lottie-player>
                        <p class="lead">Loading...</p>
                    </center>
                </div>
                <div v-else>
                    <div v-if="logos !== null && logos.length > 0" class="row">
                        <div v-for="(logo, index) in logos" class="col-6 col-md-4 col-lg-3">
                            <div @click="update_logo(logo.unique_id, logo.paid_svglogos_s3);" class="aumentarscale_btn" :class="{ 'selectedcontainer': logo_unique_id === logo.unique_id }" style="width: 100%; margin-bottom: 20px; border-radius: 0.5rem;transition: transform 100ms, box-shadow 150ms;cursor: pointer;background: #FFFFFF;">
                                <div v-if="logo.paid_svglogos_s3 === 'needs_update'" class="logo-list-sin-borde display-logos-created" style="transition: transform 100ms ease 0s, box-shadow 150ms ease 0s;display: flex;height: auto;">
                                    <img :src="'https://logo.app/paid-svglogos/'+logo.unique_id+'.svg?'+timenow" style="width: 100%; border-radius: 5px;height: auto;">
                                </div>
                                <div v-else class="logo-list-sin-borde display-logos-created" style="transition: transform 100ms ease 0s, box-shadow 150ms ease 0s;display: flex;height: auto;">
                                    <img :src="'https://paid-svglogos.s3.amazonaws.com/'+logo.unique_id+'.svg?'+timenow" style="width: 100%; border-radius: 5px;height: auto;">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <p class="lead text-center">No logos created in this account.</p>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>

    </div>
  
  </template>
  
    <script>
    import ClickOutside from 'vue-click-outside';

    export default {
      props:['propsdata'],
      data() {
        return {
          loading_business_card: true,
          timenow: Date.now(),
          tab: 'information',
          unique_id: '',
          template: '',
          modal_template: false,
          name: '',
          role: '',
          email: '',
          phone: '',
          website: '',
          address: '',
          logo_unique_id: '',
          modal_logo: false,
          loading_logos: true,
          logos: [],
          background_color: '#000000',
          name_color: '#000000',
          role_color: '#000000',
          phone_color: '#000000',
          email_color: '#000000',
          website_color: '#3f83f8',
          address_color: '#000000',
          paid_svglogos_s3: '',
          retry_axios: 1,
          finishing_business_card: false,
        };
      },
      components: {
        draggable: window['vuedraggable']
      },
      methods: {
        async load_business_card(){
            // Wait until propsdata paid is populated
            while (this.propsdata[0].paid === '') {
                // Wait for 100ms before checking again
                await new Promise(resolve => setTimeout(resolve, 100));
            }
            if(this.propsdata[0].paid === 'yes'){
                axios.post('/dashboard/cargar-business-card.php', {
                    unique_id: this.unique_id
                })
                .then(response => {
                    if(response.data === 'volver a intentar el axios para cargar formdata' && this.retry_axios <= 3){
                        this.retry_axios = this.retry_axios+1;
                    }
                    else if(response.data === 'Business card does not exist'){
                        this.$router.push('/dashboard/business-cards'); //redirect to business cards
                    }
                    else{
                        this.logo_unique_id = response.data['logo_unique_id'];
                        this.template = response.data['template'];
                        this.name = response.data['name'];
                        this.role = response.data['role'];
                        this.email = response.data['email'];
                        this.phone = response.data['phone'];
                        this.website = response.data['website'];
                        this.address = response.data['address'];
                        this.background_color = response.data['background_color'];
                        this.name_color = response.data['name_color'];
                        this.role_color = response.data['role_color'];
                        this.phone_color = response.data['phone_color'];
                        this.email_color = response.data['email_color'];
                        this.website_color = response.data['website_color'];
                        this.address_color = response.data['address_color'];
                        this.paid_svglogos_s3 = response.data['paid_svglogos_s3'];
                        this.retry_axios = 1;
                        this.loading_business_card = false;
                    }
                })
                .catch(function (error) {
                console.log(error);
                });
            }
            else{
                this.$router.push('/dashboard/business-cards'); //redirect to business cards
            }
        },
        change_tab(text) {
            this.tab = text;
        },
        show_modal_template(){
            this.modal_template = true;
        },
        hide_modal_template(){
            this.modal_template = false;
        },
        update_template(num){
            this.template = num;
            this.modal_template = false; //close modal
        },
        show_modal_logo(){
            this.modal_logo = true;
            if(this.logos.length === 0){
                this.load_logos();
            }
        },
        hide_modal_logo(){
            this.modal_logo = false;
        },
        update_logo(unique_id, where_is_file){
            this.logo_unique_id = unique_id;
            this.paid_svglogos_s3 = where_is_file;
            this.modal_logo = false; //close modal
        },
        load_logos(){
            axios.post('/dashboard/cargar-logos-unique-id.php', {
            })
            .then(response => {
                this.logos = response.data;
                this.loading_logos = false;
            })
            .catch(function (error) {
            console.log(error);
            });
        },
        save_business_card(){
            this.finishing_business_card = true;
            axios.post('/dashboard/save-business-card.php', {
                unique_id: this.unique_id,
                logo_unique_id: this.logo_unique_id,
                template: this.template,
                name: this.name,
                role: this.role,
                email: this.email,
                phone: this.phone,
                website: this.website,
                address: this.address,
                background_color: this.background_color,
                name_color: this.name_color,
                role_color: this.role_color,
                phone_color: this.phone_color,
                email_color: this.email_color,
                website_color: this.website_color,
                address_color: this.address_color
            })
            .then(response => {
                if(response.data === 'volver a intentar el axios para cargar formdata' && this.retry_axios <= 3){
                    this.retry_axios = this.retry_axios+1;
                    this.save_business_card();
                }
                else{
                    this.finishing_business_card = false;
                    this.retry_axios = 1;
                    this.$router.push('/dashboard/business-cards'); //redirect to business card editor
                }
            })
            .catch(function (error) {
            console.log(error);
            });
        },
        calculateFontSize(text, initialFontSize) {
            if(this.template === '1'){
                var maxTextWidth = 230; // Maximum width for the text elements
            }
            else if(this.template === '2'){
                var maxTextWidth = 255; // Maximum width for the text elements
            }
            else if(this.template === '3'){
                var maxTextWidth = 180; // Maximum width for the text elements
            }
            let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            let tempText = document.createElementNS("http://www.w3.org/2000/svg", "text");
            tempText.setAttribute("font-family", "Arial");
            tempText.setAttribute("font-size", initialFontSize);
            tempText.textContent = text;
            svg.appendChild(tempText);
            document.body.appendChild(svg);
            
            let textWidth = tempText.getBBox().width;
            document.body.removeChild(svg);

            if (textWidth > maxTextWidth) {
                return (initialFontSize * maxTextWidth) / textWidth;
            } else {
                return initialFontSize;
            }
        },
        calculateGroupTransform(index) {
            this.$nextTick(() => {
                const group = this.$refs['textGroup-' + index];
                if (group) {
                    const svgHeight = 250;
                    const bbox = group.getBBox();
                    const offsetY = (svgHeight - bbox.height) / 2 - bbox.y;
                    group.setAttribute('transform', `translate(0, ${offsetY})`);
                }
            });

            // Return a neutral or default value to avoid issues
            return 'translate(0, 0)';
        },
        getYPosition(field) {
            let yPosition = 0;

            if (field === 'name') {
                return yPosition;
            }

            if (field === 'role') {
                if (this.name) {
                    yPosition += 30;
                }
                return yPosition;
            }

            if (field === 'phone') {
                if (this.name) {
                    yPosition += 30;
                }
                if (this.role) {
                    yPosition += 50;
                }
                return yPosition;
            }

            if (field === 'email') {
                if (this.name) {
                    yPosition += 30;
                }
                if (this.role) {
                    yPosition += 50;
                }
                if (this.phone) {
                    yPosition += 25;
                }
                return yPosition;
            }

            if (field === 'website') {
                if (this.name) {
                    yPosition += 30;
                }
                if (this.role) {
                    yPosition += 50;
                }
                if (this.phone) {
                    yPosition += 25;
                }
                if (this.email) {
                    yPosition += 25;
                }
                return yPosition;
            }

            if (field === 'address') {
                if (this.name) {
                    yPosition += 30;
                }
                if (this.role) {
                    yPosition += 50;
                }
                if (this.phone) {
                    yPosition += 25;
                }
                if (this.email) {
                    yPosition += 25;
                }
                if (this.website) {
                    yPosition += 25;
                }
                return yPosition;
            }

            return yPosition;
        }
      },
      mounted() {
        this.unique_id = this.$route.params.business_card_id;
        this.$emit('updateprops');
        this.load_business_card();
      },
    // do not forget this section
    directives: {
    ClickOutside
    }
    };
    </script>
  


// WEBPACK FOOTER //
// src/edit-business-card.vue